// Mapeia `item.scope` (Workflow M1 §5/§6) para o caminho da API (`/api/v1/{scope}/...`) e para a rota da SPA
// sob `/me` (contexto ativo, `/me` contexts). Um tenant desconhecido não gera chamada: cai no NotFound local
// (mesmo princípio da Parte 14.7, regra 7).
import type { MeResponse } from '@giyus/api-client';

import type { WorkflowScopeRef } from '../../modules/workflow/api/contract.preview';
import { findContext } from '../context/contextResolver';

/** Segmento de escopo da API (`network`, `tenants/{id}` ou `tenants/{id}/studies/{id}`). */
export function apiScopePath(scope: WorkflowScopeRef): string {
  if (scope.level === 'Network' || !scope.tenantId) {
    return 'network';
  }
  if (scope.studySiteId) {
    return `tenants/${scope.tenantId}/studies/${scope.studySiteId}`;
  }
  return `tenants/${scope.tenantId}`;
}

/** Caminho da SPA para abrir o item no seu escopo (`/network/workflow` ou `/t/{code}/workflow`), ou `null`
 * quando o tenant não está entre os contextos do usuário (link de e-mail para um centro a que ele perdeu acesso). */
export function appScopePath(scope: WorkflowScopeRef, me: MeResponse): string | null {
  if (scope.level === 'Network' || !scope.tenantId) {
    return me.networkAccess.hasAccess ? '/network/workflow' : null;
  }
  const context = me.contexts.find((c) => c.tenantId === scope.tenantId);
  if (!context) {
    return null;
  }
  return `/t/${encodeURIComponent(context.code)}/workflow`;
}

/** Mesma regra de `findContext`, exposta aqui para quem só tem o `tenantId` (não o código). */
export function tenantCodeFor(tenantId: string | null, me: MeResponse): string | null {
  if (!tenantId) {
    return null;
  }
  return me.contexts.find((c) => c.tenantId === tenantId)?.code ?? null;
}

export { findContext };
